/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(function($){
  	$('.c-tab').each(function(i){
		var tabLinks = $(this).find('.c-tabLinks'),
			tabLink = $(this).find('.c-tabLink'),
            tabContent = $(this).find('.c-tabContent');
      
    	  tabLink.on('click', function(){
			var dataTab = $(this).data('tab');
            tabLink.removeClass('is-active');
            tabContent.hide();    
            
            $(this).addClass('is-active');
            $('#'+dataTab).show();            
          })
          
          tabLink.eq(0).trigger('click');
	})

  $('.c-toggle__head').on('click', function(){
    $(this).toggleClass('is-active');
    $(this).next().slideToggle();
  })

  $(function () {
    var speed = 500;
    $('a[href^="#"]').on('click', function () {
        var href = $(this).attr('href');
        var target = $(href == '#' || href == '' ? 'html' : href);
        var position = target.offset().top - $('section[data-section-id=header]').height();
        $('html, body').animate({ scrollTop: position }, speed, 'swing');
        window.location.hash = href;
        return false;
    });

    if (window.location.hash) {
        var hash = window.location.hash;

        if ($(hash).length) {
            $('html, body').animate({
                scrollTop: $(hash).offset().top - $('section[data-section-id=header]').height()
            }, 500, 'swing');
            return;
        }
    }
});
})